<template>
    <div id="app">
        <div class="iconImg" v-if="iconImgFlag">
            <router-link class="mains" to="/main">
                <img style="width: 50px" src="../static/img/newMain.png" alt="">
            </router-link>
            <div  class="main2" @click="back">
                <img  style="width: 50px"  src="../static/img/newBack.png" alt="">
            </div>
        </div>
        <router-view ></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                obj:{
                    name:1
                },
                isShow: false,
	            iconImgFlag:true,//返回及主页icon
            }
        },
        methods: {
            //返回上一页
            back(){
                history.back()
            },
            //判断是否登陆
            jumpToken() {
                if (localStorage.TOKEN) {
                    this.isShow = true
                } else {
                    this.isShow = true
                    // 跳转登录页
                    this.$router.push('/login')
                }
            },

            jumpFunction(){
                if (this.jumpNavigator() === 'Chrome' || this.jumpNavigator() === 'Firefox' ){

                }else{
                    alert(' 本项目支持 谷歌 、 火狐 、浏览器')
                }
            }

        },
        created() {
            console.log(this.obj.prototype);
            this.jumpFunction()
            document.title = '无人机摄影测量虚拟仿真实验'
        },
        mounted(){
	        if(this.$route.query.token){
		        let queryToken = '';
		        queryToken = decodeURIComponent(window.location.href.split("token=")[1].split("&")[0])
		        let params = {
			        data: queryToken
		        }
		        this.$axios.get(this.URL.verify,{params}).then(res =>{
			        if(res.status === 200){
				        this.$notify({
					        title: '成功',
					        message: '登陆成功',
					        type: 'success',
				        });
			        	localStorage.setItem('TOKEN', res.msg);
				        this.goMain('main')
			        }else{
				        this.commFun.errMsg(this, res.msg)
                    }
		        })
	        }else{
		        this.jumpToken()
            }
        },
	    watch: { // 路由监听：监听路由的变化，从而做出相应操作
		    $route: {
			    immediate: true, // 一旦监听到路由的变化立即执行
			    handler(to,from) { // 回调函数，两个参数，to：当前的组件，from：上一个组件
				    console.log(to)
                    if(to.path === '/webglTest'){
				    	this.iconImgFlag = false
                    }else{
	                    this.iconImgFlag = true
                    }
			    }
		    }
	    }
    }
</script>

<style>
    .mains {
        cursor: pointer;
        position: absolute;
        top: 3vh;
        left: 4%;
        z-index: 115;
    }
    .main2{
        top: 3vh;
        left: 9%;
        z-index: 115;
        cursor: pointer;
        position: absolute;
        font-size: 40px;

    }

</style>



// WEBPACK FOOTER //
// src/App.vue